<template>
  <div class="hint_wrap">
    <div :class="sourceType === '2' ? 'container table_tennis' : 'container'">
      <div v-if="type === '1'" class="content ca_space-around">
        <span>今日投票已用完</span>
        <span>明天再来吧</span>
      </div>
      <div v-if="type === '2'" class="content">
        <span>该选手投票</span>
        <span>已达上线</span>
        <span>请明日再投</span>
      </div>
      <div v-if="type === '3'" class="content">
        <span>投票成功</span>
        <img src="https://images.zhibo.tv/2021/0721/voting_succes_icon.png" alt="">
        <span>剩余{{count}}次投票机会</span>
      </div>
      <div class="btn_box">
        <span @click="center">好的</span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ['type', 'count', 'sourceType'],
  data() {
    return {
    }
  },
  methods: {
    center() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="less" scoped>
.hint_wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background: rgba(0,0,0,.5);
}
.container {
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  margin: auto;
  width: 3.15rem;
  height: 2.83rem;
  background: #CA4633;
  box-shadow: 0px .01rem .05rem 0px rgba(111, 0, 0, 0.41);
  border-radius: .1rem;
  box-sizing: border-box;
  &.table_tennis {
    background: #890605;
  }
  .content {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-size: .24rem;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #FFFEFE;
    margin-top: .41rem;
    line-height: 1;
    height: 1.17rem;
    img {
      width: .35rem;
      height: .31rem;
    }
  }
  .ca_space-around {
    justify-content: space-around;
  }
  .btn_box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: .35rem;
    box-sizing: border-box;
    span {
      width: 2.57rem;
      height: .58rem;
      background: #F9CE54;
      box-shadow: 0px .01rem .05rem 0px rgba(111, 0, 0, 0.41);
      border-radius: .1rem;
      font-size: .24rem;
      font-family: PingFang SC;
      font-weight: 600;
      color: #BB0E13;
      text-align: center;
      line-height: .58rem;
    }
  }
}
</style>
